import {
  Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Spacer,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch } from 'react-redux';

interface ValidationInventory {
  workListInventoryId: number;
  trackingNo: string;
  validationStatus: string;
  validationRemarks: string;
  deliveryOption: string;
  faxNo: string;
}

interface InventoryItemConfirmModal {
  isOpen: boolean;
  onClose: () => void;
  selectedItem: any;
  setSelectedItem: any;
  setCopied: any;
}

function HIMInventoryModalPopup({
  isOpen,
  onClose,
  selectedItem,
  setSelectedItem,
  setCopied,
}: InventoryItemConfirmModal) {
  const handleInventoryStatusChange = (value: string) => {
    setInventoryStatus(value);

    const newStatus = value;
    setValidationData(prevValidationData => ({
      ...prevValidationData,

      workListInventoryId: selectedItem?.WorkListInventoryId,
      trackingNo: '',
      validationStatus: newStatus,
      validationRemarks: '',
      deliveryOption: '',
      faxNo: '',
    }));
  };

  const validationDataSkeleton = {
    workListInventoryId: selectedItem?.WorkListInventoryId,
    trackingNo: '',
    validationStatus: 'Success',
    validationRemarks: '',
    deliveryOption: '',
    faxNo: '',
  };

  const { accounts } = useMsal();
  const userEmail = accounts[0]?.username || '';

  const [singleRowData, setSingleRowData] = useState<any[]>([]);

  const [InventoryStatus, setInventoryStatus] = useState('Success');
  const [validationData, setValidationData] = useState<ValidationInventory>(
    validationDataSkeleton
  );
  const toast = useToast();

  const ValidateSelectedRow = async () => {
    try {
      const id = data.WorkListInventoryId;
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const payload = {
          workListInventoryId: id,
          trackingNo: validationData.trackingNo,
          validationStatus: validationData.validationStatus,
          validationRemarks: data.Remarks,
          deliveryOption: data.DeliveryOption,
          faxNo: validationData.faxNo,
        };
        setCopied(true);
console.log('him data submit', payload);
        const validationResponse = await axios.put(
          baseurl + '/Him/InventoryAccount',
          payload,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          }
        );
        if (validationResponse.data.success) {
          setCopied(true);
          toast({
            title: 'Success ',
            position: 'top',
            description: 'Inventory Item has been successfully validated!',
            status: 'success',
            duration: 9000,
            isClosable: true,
          });
        } else {
          throw new Error('Failed to update validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error updating validation data:', error);
    }
  };

  const [data, setdata] = useState({
    WorkListInventoryId: 0,
    appealId: '',
    MRN: '',
    AccountNo: '',
    RegionCode: '',
    PlanType: '',
    HealthplanName: '',
    Remarks:'',
    CodeType: '',
    MD_NoOfpages: '',
    p_name: '',
    P_DOB: '',
    ClaimNumber: '',
    totalCharges: '',
    insuranceBalance: '',
    currentAccBalance: '',
    patientBalance: '',
    DeliveryOption: '',
    p_AdmitDate: '',
    p_DischargeDate: '',
    MergeFilePath: '',
    transactionState:'',
    workQueueInventoryStatus: '',
    LockedBy: '',
    ServiceType: '',
    nextDeliveryOption: '',
    TaskName: '',
    TaskNote: '',
    documents: '',
    Documentstobeincluded: '',
    DocumentLiseted: '',
    Coverletterpayer: '',
    TypeOfCoverLetter: '',
    InsurancePlan: '',
    MethodofDelivery: '',
    PortalName: '',
    PayerAddress: '',
    SendRecordsTo: '',
    ClaimFormRequired: '',
    CoverLetterCreatedby: '',
    DeadLine: '',
    EncounterClaimNo: '',
});

  useEffect(() => {
    Store.subscribe(() => {
      setdata({
        ...data,
        WorkListInventoryId: Store.getState().HIMInventoryItem.value.WorkListInventoryId,
        appealId: Store.getState().HIMInventoryItem.value.appealId,
        MRN: Store.getState().HIMInventoryItem.value.MRN,
        AccountNo: Store.getState().HIMInventoryItem.value.AccountNo,
        RegionCode: Store.getState().HIMInventoryItem.value.RegionCode,
        PlanType: Store.getState().HIMInventoryItem.value.PlanType,
        HealthplanName: Store.getState().HIMInventoryItem.value.HealthplanName,
        Remarks: Store.getState().HIMInventoryItem.value.Remarks,
        CodeType: Store.getState().HIMInventoryItem.value.CodeType,
        MD_NoOfpages: Store.getState().HIMInventoryItem.value.MD_NoOfpages,
        p_name: Store.getState().HIMInventoryItem.value.p_name,
        P_DOB: Store.getState().HIMInventoryItem.value.P_DOB,
        ClaimNumber: Store.getState().HIMInventoryItem.value.ClaimNumber,
        totalCharges: Store.getState().HIMInventoryItem.value.totalCharges,
        insuranceBalance: Store.getState().HIMInventoryItem.value.insuranceBalance,
        currentAccBalance: Store.getState().HIMInventoryItem.value.currentAccBalance,
        patientBalance: Store.getState().HIMInventoryItem.value.patientBalance,
        DeliveryOption: Store.getState().HIMInventoryItem.value.DeliveryOption,
        p_AdmitDate: Store.getState().HIMInventoryItem.value.p_AdmitDate,
        p_DischargeDate: Store.getState().HIMInventoryItem.value.p_DischargeDate,
        MergeFilePath: Store.getState().HIMInventoryItem.value.MergeFilePath,
        transactionState: Store.getState().HIMInventoryItem.value.transactionState,
        workQueueInventoryStatus: Store.getState().HIMInventoryItem.value.workQueueInventoryStatus,
        LockedBy: Store.getState().HIMInventoryItem.value.LockedBy,
        ServiceType: Store.getState().HIMInventoryItem.value.ServiceType,
        nextDeliveryOption: Store.getState().HIMInventoryItem.value.nextDeliveryOption,
        TaskName: Store.getState().HIMInventoryItem.value.TaskName,
        TaskNote: Store.getState().HIMInventoryItem.value.TaskNote,
        documents: Store.getState().HIMInventoryItem.value.documents,
        Documentstobeincluded: Store.getState().HIMInventoryItem.value.Documentstobeincluded,
        DocumentLiseted: Store.getState().HIMInventoryItem.value.DocumentLiseted,
        Coverletterpayer: Store.getState().HIMInventoryItem.value.Coverletterpayer,
        TypeOfCoverLetter: Store.getState().HIMInventoryItem.value.TypeOfCoverLetter,
        InsurancePlan: Store.getState().HIMInventoryItem.value.InsurancePlan,
        MethodofDelivery: Store.getState().HIMInventoryItem.value.MethodofDelivery,
        PortalName: Store.getState().HIMInventoryItem.value.PortalName,
        PayerAddress: Store.getState().HIMInventoryItem.value.PayerAddress,
        SendRecordsTo: Store.getState().HIMInventoryItem.value.SendRecordsTo,
        ClaimFormRequired: Store.getState().HIMInventoryItem.value.ClaimFormRequired,
        CoverLetterCreatedby: Store.getState().HIMInventoryItem.value.CoverLetterCreatedby,
        DeadLine: Store.getState().HIMInventoryItem.value.DeadLine,
        EncounterClaimNo: Store.getState().HIMInventoryItem.value.EncounterClaimNo,
      });
      setValidationData((prevdata) => ({
        ...prevdata,
        deliveryOption: Store.getState().HIMInventoryItem.value.DeliveryOption,
        validationRemarks: Store.getState().HIMInventoryItem.value.Remarks,
      }
      ))
    });

}, []);

  const unlockSelectedRow = async () => {
    try {
      const id = selectedItem?.WorkListInventoryId;
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const validationResponse = await axios.delete(
          baseurl + '/Validation/Accounts/' + id,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          }
        );
        if (validationResponse.data.success) {
          setCopied(true);
        } else {
          throw new Error('Failed to delete validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error deleting validation data:', error);
    }
  };

  const lockSelectecRow = async () => {
    try {
      const id = selectedItem?.WorkListInventoryId;
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const validationResponse = await axios.get(
          baseurl + '/Validation/Accounts/' + id + '/' + userEmail,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + tokenResponse.data.token,
            },
          }
        );
        if (validationResponse.data.success) {
          setCopied(true);
          setSingleRowData(validationResponse.data.result);
          const resultDeliveryOption = (
            validationResponse.data.result as any
          )?.[0]?.deliveryoption;

          if (resultDeliveryOption === null || resultDeliveryOption === ' ') {
            setValidationData(prevValidationData => ({
              ...prevValidationData,
              deliveryOption: 'Upload',
            }));
          } else {
            setValidationData(prevValidationData => ({
              ...prevValidationData,
              deliveryOption: resultDeliveryOption,
            }));
          }
        } else {
          throw new Error('Failed to fetch validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error fetching validation data:', error);
    }
  };

  useEffect(() => {
    lockSelectecRow();
  }, [InventoryStatus, selectedItem]);

  const handleSubmit = (event: any) => {
    event.preventDefault(); // Prevent the default form submission behavior

    if (
      validationData.validationStatus === 'Success' &&
      selectedItem?.DeliveryOption === 'Upload' &&
      validationData.trackingNo === ''
    ) {
      toast({
        title: 'Required Field',
        position: 'top',
        description: 'Tracking Number is required for successful validation!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    } else if (
      validationData.validationStatus === 'Failed' &&
      validationData.validationRemarks === ''
    ) {
      toast({
        title: 'Required Field',
        position: 'top',
        description: 'Note is required for failed validation!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    } else {
      ValidateSelectedRow();
      setValidationData(prevValidationData => ({
        ...prevValidationData,
        workListInventoryId: selectedItem?.WorkListInventoryId,
        trackingNo: '',
        validationStatus: 'Success',
        validationRemarks: '',
        deliveryOption: '',
        faxNo: '',
      }));
      onClose();
    }
  };

  return (
    <>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={() => {
          onClose();
          unlockSelectedRow();
        }}
        onOverlayClick={() => {
          setSelectedItem(null);
          setInventoryStatus('Success');
          unlockSelectedRow();
          setValidationData(prevValidationData => ({
            ...prevValidationData,
            workListInventoryId: selectedItem?.WorkListInventoryId,
            trackingNo: '',
            validationStatus: 'Success',
            validationRemarks: '',
            deliveryOption: '',
            faxNo: '',
          }));
        }}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit}>
            <ModalHeader textAlign="center">
              HIM Inventory
            </ModalHeader>
            <ModalCloseButton
              color="white"
              bg="#002677"
              onClick={() => {
                setSelectedItem(null);
                setInventoryStatus('Success');
                unlockSelectedRow();
                setValidationData(prevValidationData => ({
                  ...prevValidationData,
                  workListInventoryId: selectedItem?.WorkListInventoryId,
                  trackingNo: '',
                  validationStatus: 'Success',
                  validationRemarks: '',
                  deliveryOption: '',
                  faxNo: '',
                }));
              }}
            />
            <ModalBody>
              <Table fontSize="15px" size="sm">
                <Tbody>
                  <Tr>
                    <Td fontWeight="bold">Account No:</Td>
                    <Td>{data.AccountNo}</Td>
                    <Td fontWeight="bold">Patient Name:</Td>
                    <Td>{data.p_name}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Claim No:</Td>
                    <Td>{data.ClaimNumber}</Td>
                    <Td fontWeight="bold">Code Type:</Td>
                    <Td>{data.CodeType}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">MRN:</Td>
                    <Td>{data.MRN}</Td>
                    <Td fontWeight="bold">Service Type:</Td>
                    <Td>{data.ServiceType}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Patient DOB:</Td>
                    <Td>
                      {data.P_DOB ? new Date(data.P_DOB).toLocaleDateString() : ''}
                    </Td>
                    <Td fontWeight="bold">Plan Type:</Td>
                    <Td>{data.PlanType}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Patient Admit Date:</Td>
                    <Td>
                      {data.p_AdmitDate ? new Date(data.p_AdmitDate).toLocaleDateString() : ''}
                    </Td>
                    <Td fontWeight="bold">Patient Discharge Date:</Td>
                    <Td>{data.p_DischargeDate ? new Date(data.p_DischargeDate).toLocaleDateString() : ''}
                    </Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Number of Pages:</Td>
                    <Td>{data.MD_NoOfpages}</Td>

                    <Td fontWeight="bold">Total Charges:</Td>
                    <Td>{data.totalCharges}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Method of Delivery:</Td>
                    <Td>{data.MethodofDelivery}</Td>

                    <Td fontWeight="bold">Insurance Balance:</Td>
                    <Td>{data.insuranceBalance}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Next Delivery Option:</Td>
                    <Td>{data.nextDeliveryOption}</Td>
                    <Td fontWeight="bold">Current Balance:</Td>
                    <Td>{data.currentAccBalance}</Td>
                  </Tr>

                  <Tr>
                    <Td fontWeight="bold">Health Plan:</Td>
                    <Td colSpan={3}>
                      {data.HealthplanName} - {data.InsurancePlan}
                    </Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Payer Address:</Td>
                    <Td colSpan={3}>
                      {data.PayerAddress}
                    </Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Task Name:</Td>
                    <Td colSpan={3}>
                      {data.TaskName}
                    </Td>
                  </Tr>

                  <Tr>
                    <Td fontWeight="bold">File Path:</Td>
                    <Td colSpan={3}>
                      <Flex>
                        <Tooltip
                          hasArrow
                          label={data.MergeFilePath}
                          placement="top"
                          bg="gray.300"
                          color="black"
                        >
                          <Text
                            maxWidth="350px"
                            overflow="hidden"
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                          >
                            {data.MergeFilePath}
                          </Text>
                        </Tooltip>
                        <MdContentCopy
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={e => {
                            navigator.clipboard.writeText(
                              data.MergeFilePath
                            );

                            toast({
                              title: 'Success',
                              position: 'top',
                              description:
                                'File Path has been copied successfully !',
                              status: 'success',
                              duration: 9000,
                              isClosable: true,
                            });
                          }}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">Task Note:</Td>
                    <Td colSpan={3}>
                      <Flex>
                        <Tooltip
                          hasArrow
                          label={data.TaskNote}
                          placement="top"
                          bg="gray.300"
                          color="black"
                        >
                          <Text
                            maxWidth="350px"
                            overflow="hidden"
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                          >
                            {data.TaskNote}
                          </Text>
                        </Tooltip>
                        <MdContentCopy
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={e => {
                            navigator.clipboard.writeText(
                              data.TaskNote
                            );

                            toast({
                              title: 'Success',
                              position: 'top',
                              description:
                                'Task Note has been copied successfully !',
                              status: 'success',
                              duration: 9000,
                              isClosable: true,
                            });
                          }}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
              <Center>
                <RadioGroup
                  mt="15px"
                  defaultValue="Success"
                  onChange={value => handleInventoryStatusChange(value)}
                >
                  <Stack spacing={5} direction="row">
                    <Radio colorScheme="green" value="Success" size="lg">
                      Approve
                    </Radio>
                    <Radio colorScheme="red" value="Failed" size="lg">
                      Decline
                    </Radio>
                  </Stack>
                </RadioGroup>
              </Center>
              <Flex display="flex" flexDirection="row">
                <FormControl isRequired mt="15px">
                  <FormLabel>Send to:</FormLabel>
                  <Select
                    placeholder='--Select-- '
                    maxWidth="90%"
                    mr="5px"
                    value={
                      validationData.deliveryOption === ''
                        ? data.DeliveryOption
                        : validationData.deliveryOption
                    }
                    onChange={event => {
                      const newDelivery = event.target.value;
                      setValidationData(prevValidationData => ({
                        ...prevValidationData,
                        deliveryOption: newDelivery,
                      }));
                    }}
                  >
                    <option value="Upload">Upload</option>
                    <option value="Fax">Fax</option>
                    <option value="Print">Print</option>
                    <option value="UHC Upload">UHC UPLOAD</option>
                    <option value="Availity Upload">AVAILITY UPLOAD</option>
                  </Select>
                </FormControl>
                {validationData.deliveryOption === 'Fax' ? (
                  <FormControl mt="15px">
                    <FormLabel>Phone No:</FormLabel>
                    <InputGroup>
                      <InputLeftAddon>+1</InputLeftAddon>
                      <Input
                        type="number"
                        placeholder="Phone Number"
                        onChange={event => {
                          const newFaxNo = event.target.value;
                          setValidationData(prevValidationData => ({
                            ...prevValidationData,
                            faxNo: newFaxNo,
                          }));
                        }}
                      />
                    </InputGroup>
                  </FormControl>
                ) : (
                  ''
                )}
              </Flex>
              {InventoryStatus === 'Success' &&
              validationData.deliveryOption === 'Upload' ? (
                <>
                  <FormControl isRequired mt="15px">
                    <FormLabel>Tracking Number:</FormLabel>
                    <Input
                      placeholder="Tracking Number"
                      onChange={event => {
                        const newTracking = event.target.value;
                        setValidationData(prevValidationData => ({
                          ...prevValidationData,
                          trackingNo: newTracking,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl mt="15px">
                    <FormLabel>Remarks:</FormLabel>
                    <Textarea
                      placeholder="Write Some notes"
                      onChange={event => {
                        const newNote = event.target.value;
                        setValidationData(prevValidationData => ({
                          ...prevValidationData,
                          validationRemarks: newNote,
                        }));
                      }}
                    />
                  </FormControl>
                </>
              ) : InventoryStatus === 'Success' ? (
                <FormControl mt="15px">
                  <FormLabel>Note:</FormLabel>
                  <Textarea
                    placeholder="Write Some notes"
                    onChange={event => {
                      const newNote = event.target.value;
                      setValidationData(prevValidationData => ({
                        ...prevValidationData,
                        validationRemarks: newNote,
                      }));
                    }}
                  />
                </FormControl>
              ) : (
                <>
                  <FormControl isRequired mt="15px">
                    <FormLabel>Note:</FormLabel>
                    <Textarea
                      placeholder="Write Some notes"
                      onChange={event => {
                        const newNote = event.target.value;
                        setValidationData(prevValidationData => ({
                          ...prevValidationData,
                          validationRemarks: newNote,
                        }));
                      }}
                    />
                  </FormControl>
                </>
              )}
            </ModalBody>
            <ModalFooter justifyContent="center">
              <Button
                onClick={() => {
                  setSelectedItem(null);
                  setInventoryStatus('Success');
                  unlockSelectedRow();
                  setValidationData(prevValidationData => ({
                    ...prevValidationData,
                    workListInventoryId: selectedItem?.WorkListInventoryId,
                    trackingNo: '',
                    validationStatus: 'Success',
                    validationRemarks: '',
                    deliveryOption: '',
                    faxNo: '',
                  }));
                  onClose();
                }}
                bg="#002677"
                color="white"
                h="30px"
                w="fit-content"
                mr="5px"
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                bg="#002677"
                color="white"
                h="30px"
                w="fit-content"
                type="submit"
              >
                Confirm
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}

export default HIMInventoryModalPopup;
